module.exports = __webpack_public_path__ + "media/images/syntax/53-54-85777b4eee172e53994d21febb38b123.png";